/**
 * @generated SignedSource<<e3271acd613db86c02380e9768ba9953>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingSlackRequestInviteFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMemberOnboardingFormStoreFragment">;
  readonly " $fragmentType": "MemberOnboardingSlackRequestInviteFragment";
};
export type MemberOnboardingSlackRequestInviteFragment$key = {
  readonly " $data"?: MemberOnboardingSlackRequestInviteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingSlackRequestInviteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingSlackRequestInviteFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMemberOnboardingFormStoreFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "1a1826426703b7c272b9334732da6add";

export default node;
